export default __webpack_public_path__ + "static/media/ConsuptionImg.0d5a19cb.svg";